'use client';

import Button from '@enlighten/design-system/dist/Button';
import Drawer from '@enlighten/design-system/dist/Drawer';
import Grid from '@enlighten/design-system/dist/Grid';
import IconButton from '@enlighten/design-system/dist/IconButton';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';

import ArrowIcon from '@/assets/images/arrow.svg';
import CloseIcon from '@/assets/images/close.svg';

export default function Tutorial({ children }: PropsWithChildren) {
	const [openDrawer, setOpenDrawer] = useState<boolean>(false);

	return (
		<>
			<Button
				onClick={() => setOpenDrawer(true)}
				sx={{
					fontSize: 18,
					padding: '13.5px 31px',
					'& svg': {
						width: { xs: 16, md: 24 },
						height: { xs: 16, md: 24 },
					},
				}}
			>
				내게 필요한 서비스 찾기&nbsp;&nbsp;
				<ArrowIcon fill="white" />
			</Button>
			<Drawer
				anchor="left"
				open={openDrawer}
				onClose={(_, reason) => {
					if (reason === 'backdropClick') {
						setOpenDrawer(false);
					}
				}}
				slotProps={{
					paper: {
						sx: {
							maxWidth: { xs: '100%', md: 840 },
							width: '100%',
						},
					},
				}}
			>
				<Grid
					position="fixed"
					container
					justifyContent="flex-end"
					maxWidth={840}
					borderBottom={(theme) => `1px solid ${theme.palette.grey['300']}`}
					padding={{ xs: '20px', md: 4 }}
					zIndex={99}
					bgcolor="common.white"
				>
					<IconButton onClick={() => setOpenDrawer(false)} sx={{ padding: 0 }} title="drawer close">
						<CloseIcon width={21} height={21} />
					</IconButton>
				</Grid>
				<Grid container flex={1} alignItems={{ xs: 'flex-start', md: 'center' }} marginTop={{ xs: '41px', md: '53px' }}>
					{children}
				</Grid>
			</Drawer>
		</>
	);
}
